import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { tagLabel } from "@/lib/visitSchema";
import { FileImage, X } from "lucide-react";

/* Thumbnail for an uploaded file. Fetches the blob only when the viewer is allowed to see photos. */
export default function FileThumb({ fileId, tag, canPreview, onRemove, onRetag, tagOptions, index, testId }) {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    if (!canPreview) return undefined;
    let objectUrl = null;
    let cancelled = false;
    api.get(`/files/${fileId}`, { responseType: "blob", retry: false })
      .then((res) => { if (!cancelled) { objectUrl = URL.createObjectURL(res.data); setUrl(objectUrl); } })
      .catch(() => { if (!cancelled) setFailed(true); });
    return () => { cancelled = true; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [fileId, canPreview]);

  return (
    <div className="relative aspect-square rounded-md overflow-hidden border border-slate-200 bg-slate-100 group" data-testid={testId}>
      {url && !failed ? (
        <a href={url} target="_blank" rel="noreferrer" className="block w-full h-full"><img src={url} alt={tag ? tagLabel(tag) : "upload"} className="w-full h-full object-cover" /></a>
      ) : (
        <div className="w-full h-full flex flex-col items-center justify-center text-slate-400 gap-1 px-1 text-center">
          <FileImage className="h-5 w-5" />
          <span className="text-[10px] leading-tight">{failed ? "Hidden" : `Photo ${index + 1}`}</span>
        </div>
      )}
      {tag && (onRetag ? (
        <select value={tag} onChange={(e) => onRetag(fileId, e.target.value)} className="absolute bottom-1 left-1 right-1 text-[10px] rounded bg-white/95 border border-slate-200 px-1 py-0.5" aria-label="Photo tag" data-testid={`${testId}-tag`}>
          {tagOptions.map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}
        </select>
      ) : (
        <span className="absolute bottom-1 left-1 bg-slate-950/80 text-white text-[9px] px-1.5 py-0.5 rounded-full">{tagLabel(tag)}</span>
      ))}
      {onRemove && (
        <button type="button" onClick={() => onRemove(fileId)} className="absolute top-1 right-1 bg-white/90 rounded-full p-1 shadow hover:bg-red-50" aria-label="Remove photo" data-testid={`${testId}-remove`}>
          <X className="h-3 w-3 text-red-600" />
        </button>
      )}
    </div>
  );
}
